import { makeStyles, Theme } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { defaultDarkChipBackground } from "tools/theme";

type StyleProps = { isDark?: boolean };

export default makeStyles<Theme, StyleProps>((theme) => ({
  trigger: {
    textTransform: "none",
    padding: theme.spacing(1.5),
    minWidth: 0,
    borderRadius: theme.spacing(0.75),
  },
  triggerLabel: {
    lineHeight: 1,
    color: ({ isDark }) => (isDark ? theme.palette.common.white : grey[400]),
  },
  paper: {
    minWidth: 180,
    "&.MuiPaper-root": {
      backgroundColor: ({ isDark }) =>
        isDark ? defaultDarkChipBackground : theme.palette.chipBackground.main,
    },
  },
  item: {
    padding: theme.spacing(2, 1),
  },
  itemLabel: {
    lineHeight: 1,
    flex: 1,
  },
  itemLabelUnselected: {
    color: ({ isDark }) =>
      isDark ? grey[500] : theme.palette.contrastText.main,
  },
  itemLabelSelected: {
    color: theme.palette.primary.main,
  },
}));
